import React from 'react';

const FaqPage = () => {
    return (
        <div>
            <h1>FAQ</h1>
        </div>
    );
};

export default FaqPage;
